import { TGetPublishTermsResponseSchema } from '../internalTypes';
import { TGetPublishTermsResult } from '../types';
import { getSelectedServiceId } from './getSelectedServiceId';
import { getServices } from './getServices';
import { getServiceId } from './getServiceId';
import { mapServices } from './mapServices';
import { getAuctionTerm } from './getAuctionTerm';
import { mapAuction } from './mapAuction';
import { getCalltrackingTerm } from './getCalltrackingTerm';
import { mapCalltracking } from './mapCalltracking';

export const mapPublishTerms = (response: TGetPublishTermsResponseSchema): TGetPublishTermsResult => {
  switch (response.status) {
    case 'ok': {
      const { data } = response;

      const message = data.message || null;

      const terms = getServices(data);
      const serviceIds = terms.map(getServiceId);
      const services = mapServices(terms);
      const selectedServiceId = getSelectedServiceId(terms);

      const auctionTerm = getAuctionTerm(data);
      const auction = mapAuction(auctionTerm);

      const calltrackingTerm = getCalltrackingTerm(data);
      const calltracking = mapCalltracking(calltrackingTerm);

      const publishTerms = {
        serviceIds,
        services,
        selectedServiceId,
        message,
      };

      return {
        success: true,
        payload: {
          publishTerms,
          auction,
          calltracking,
        },
      };
    }

    default: {
      const { data } = response;

      return {
        success: false,
        payload: data.message,
      };
    }
  }
};
